import { Shell } from ".";
import { MenuRoute } from "../../components/menu";
import ExternalLaunchShell from "./external";
import { ShellRouteNames } from "./route-names";

export const ShellRouteStates: MenuRoute[] = [
  {
    name: ShellRouteNames.shell,
    abstract: true,
    component : Shell,
    sticky: true,
    data: {
      title: "shell",
      authed: true,
    },
  },
  {
    name: ShellRouteNames.externalShell,
    component: ExternalLaunchShell,
    abstract: true,
    sticky: true,
    data: {
      title: "",
    },
  },
];
